export function bucketsToMap(buckets = []) {
  const m = {};
  for (const b of buckets) m[b.val] = b.count;
  return m;
}

export function solrFacetsToUi(solr) {
  return {
    dataslug: bucketsToMap(solr?.dataslug?.buckets),
    occupation: bucketsToMap(solr?.occupation?.buckets),
    birthLocation: bucketsToMap(solr?.birthLocation?.buckets),
    deathLocation: bucketsToMap(solr?.deathLocation?.buckets),

    exists: {
      abstract: {
        has: solr?.exists_abstract_has?.count || 0,
        missing: solr?.exists_abstract_missing?.count || 0,
      },
      publication: {
        has: solr?.exists_publication_has?.count || 0,
        missing: solr?.exists_publication_missing?.count || 0,
      },
    },

    ranges: {
      birthDate: { min: solr?.birthDate_min ?? 0, max: solr?.birthDate_max ?? 0 },
      deathDate: { min: solr?.deathDate_min ?? 0, max: solr?.deathDate_max ?? 0 },
      birthYear: { min: solr?.birthYear_min ?? 0, max: solr?.birthYear_max ?? 0 },
      deathYear: { min: solr?.deathYear_min ?? 0, max: solr?.deathYear_max ?? 0 },
    },
  };
}
